import React, { useState, useEffect, useContext, useCallback, useMemo } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../UserContext";

const IntentionTechniquePage = () => {
  const [intentions, setIntentions] = useState([]);
  const [newIntention, setNewIntention] = useState({
    intention: "",
    type: "",
    definition: "",
    techniques: {},
  });
  const [isEditing, setIsEditing] = useState(false);
  const [editIntentionId, setEditIntentionId] = useState("");
  const [viewIntentionId, setViewIntentionId] = useState(null);
  // const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  const [email] = useState(""); // eslint-disable-line no-unused-vars
  const [password] = useState(""); // eslint-disable-line no-unused-vars
  const [isFormVisible, setIsFormVisible] = useState(false);
  const apiBaseURL = process.env.REACT_APP_BACKEND_API_URL;
  const navigate = useNavigate();
  const { user } = useContext(UserContext);

  //   const fetchIntentions = useCallback(async () => {
  //    try {
  //      const response = await axios.get(`${apiBaseURL}/intentions`);
  //      setIntentions(response.data);
  //    } catch (error) {
  //      console.error("Error fetching intentions:", error);
  //    }
  //  }, [apiBaseURL]); 

  const stableApiURL = useMemo(() => process.env.REACT_APP_BACKEND_API_URL, []);

  const fetchIntentions = useCallback(async () => {
    try {
      const response = await axios.get(`${stableApiURL}/intentions`);
      setIntentions(response.data);
    } catch (error) {
      console.error("Error fetching intentions:", error);
    }
  }, [stableApiURL]);


  useEffect(() => {
    if (
      user.user_role === "ac9be322-db89-4beb-854a-46f2c91de374" ||
      user.user_role === "5aee1e31-cc95-49d9-9ed7-10c4e4b6fdef"
    ) {
      console.log("you are admin", user.user_id);
      fetchIntentions();
    } else {
      navigate("/");
      console.log("you are not admin");
    }
  }, [fetchIntentions, navigate, user.user_id, user.user_role]);

  // const fetchIntentions = async () => {
  //   try {
  //     const response = await axios.get(`${apiBaseURL}/intentions`);
  //     setIntentions(response.data);
  //   } catch (error) {
  //     console.error("Error fetching intentions:", error);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEditing) {
        await axios.put(
          `${apiBaseURL}/intentions/${editIntentionId}`,
          newIntention,
          {
            params: {
              email,
              password,
            },
          }
        );
        setIsEditing(false);
      } else {
        await axios.post(`${apiBaseURL}/intentions`, newIntention, {
          params: {
            email,
            password,
          },
        });
      }
      setNewIntention({
        intention: "",
        type: "Neutral",
        definition: "",
        techniques: {},
      });
      fetchIntentions();
      setIsFormVisible(false);
    } catch (error) {
      console.error("Error submitting intention:", error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this intention?")) {
      try {
        await axios.delete(`${apiBaseURL}/intentions/${id}`, {
          params: {
            email,
            password,
          },
        });
        fetchIntentions();
      } catch (error) {
        console.error("Error deleting intention:", error);
      }
    }
  };

  const handleEdit = (intention) => {
    setNewIntention({
      intention: intention.intention,
      type: intention.type,
      definition: intention.definition,
      techniques: intention.techniques,
    });
    setEditIntentionId(intention.id);
    setIsEditing(true);
    setIsFormVisible(true);
  };

  const handleView = (intentionId) => {
    setViewIntentionId(intentionId);
  };

  const handleCloseForm = () => {
    setIsFormVisible(false);
    setViewIntentionId(null);
  };

  const handleAddIntention = () => {
    setIsEditing(false);
    setNewIntention({
      intention: "",
      type: "Neutral",
      definition: "",
      techniques: {},
    });
    setIsFormVisible(true);
  };

  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return `${text.slice(0, maxLength)}...`;
    }
    return text;
  };

  const handleSort = (criteria) => {
    let sortedIntentions = [...intentions];

    if (criteria === "type") {
      sortedIntentions.sort((a, b) => a.type.localeCompare(b.type));
    } else if (criteria === "lastModified") {
      sortedIntentions.sort((a, b) => {
        const dateA = new Date(a.updated_at);
        const dateB = new Date(b.updated_at);
        if (isNaN(dateA) || isNaN(dateB)) {
          console.error(
            "Invalid date format for intention",
            a.intention,
            a.updated_at
          );
          return 0;
        }
        return dateB - dateA;
      });
    }
    setIntentions(sortedIntentions);
  };

  const exportAsJSON = () => {
    const jsonString = JSON.stringify(intentions, null, 2);
    const blob = new Blob([jsonString], { type: "application/json" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "intentions.json";
    link.click();
  };

  const exportAsExcel = () => {
    const formattedData = intentions.map((intention) => ({
      Intention: intention.intention,
      Type: intention.type,
      Definition: intention.definition,
      Techniques: Object.entries(intention.techniques)
        .map(([technique, description]) => `${technique}: ${description}`)
        .join(", "),
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Intentions");

    XLSX.writeFile(workbook, "intentions.xlsx");
  };

  return (
    <div className="mx-auto p-10 text-black font-serif">
      {isFormVisible && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-80 flex items-center justify-center"
          onClick={handleCloseForm}
        >
          <div
            className="overflow-y-auto bg-white p-8 rounded-2xl shadow-2xl max-h-[90%] w-full max-w-4xl relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={handleCloseForm}
              className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-gray-200 text-gray-600 rounded-full hover:bg-gray-300 transition"
            >
              ✖
            </button>
            <h2 className="text-2xl font-semibold text-gray-700 mb-6">
              {isEditing ? "Edit Intention" : "Add New Intention"}
            </h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Intention Name */}
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-2">
                  Intention
                </label>
                <input
                  type="text"
                  value={newIntention.intention}
                  onChange={(e) =>
                    setNewIntention({
                      ...newIntention,
                      intention: e.target.value,
                    })
                  }
                  className="block w-full p-3 border border-gray-300 bg-gray-200 focus:ring-2 focus:ring-blue-500 transition"
                  required
                />
              </div>

              {/* Intention Definition */}
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-2">
                  Intention Definition
                </label>
                <textarea
                  value={newIntention.definition}
                  onChange={(e) =>
                    setNewIntention({
                      ...newIntention,
                      definition: e.target.value,
                    })
                  }
                  className="block w-full p-3 border border-gray-300 bg-gray-200 focus:ring-2 focus:ring-blue-500 transition"
                  rows="4"
                  placeholder="Provide a detailed definition for the intention"
                />
              </div>

              {/* Intention Type */}
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-2">
                  Type
                </label>
                <select
                  value={newIntention.type}
                  onChange={(e) =>
                    setNewIntention({ ...newIntention, type: e.target.value })
                  }
                  className="block w-full p-3 border border-gray-300 bg-gray-200 focus:ring-2 focus:ring-blue-500 transition"
                >
                  <option value="Exploratory">Exploratory</option>
                  <option value="Neutral">Neutral</option>
                  <option value="Action">Action</option>
                </select>
              </div>

              {/* Techniques */}
              <div>
                <div className="flex items-center justify-between mb-4">
                  <label className="text-sm font-medium text-gray-600">
                    Techniques
                  </label>
                  <button
                    type="button"
                    onClick={() => {
                      setNewIntention({
                        ...newIntention,
                        techniques: {
                          ...newIntention.techniques,
                          "": "",
                        },
                      });
                    }}
                    className="px-2 py-1 bg-gray-400 text-black rounded-lg hover:bg-gray-500 transition"
                  >
                    Add Technique
                  </button>
                </div>
                {Object.entries(newIntention.techniques).map(
                  ([technique, description], index) => (
                    <div key={index} className="mb-4 rounded-lg">
                      <input
                        type="text"
                        placeholder="Technique Name"
                        value={technique}
                        onChange={(e) => {
                          const updatedTechniques = {
                            ...newIntention.techniques,
                          };
                          const value = updatedTechniques[technique];
                          delete updatedTechniques[technique];
                          updatedTechniques[e.target.value] = value;
                          setNewIntention({
                            ...newIntention,
                            techniques: updatedTechniques,
                          });
                        }}
                        className="block w-full mb-2 p-2 bg-gray-200 border border-gray-300 focus:ring-2 focus:ring-blue-500 transition"
                      />
                      <textarea
                        placeholder="Technique Description"
                        value={description}
                        onChange={(e) => {
                          setNewIntention({
                            ...newIntention,
                            techniques: {
                              ...newIntention.techniques,
                              [technique]: e.target.value,
                            },
                          });
                        }}
                        className="block w-full mb-2 p-2 bg-gray-200 border border-gray-300 focus:ring-2 focus:ring-blue-500 transition"
                        rows="8"
                      />
                      <button
                        type="button"
                        onClick={() => {
                          const updatedTechniques = {
                            ...newIntention.techniques,
                          };
                          delete updatedTechniques[technique];
                          setNewIntention({
                            ...newIntention,
                            techniques: updatedTechniques,
                          });
                        }}
                        className="px-2 py-1 bg-gray-300 text-black rounded-lg hover:bg-red-200 transition"
                      >
                        Remove Technique
                      </button>
                    </div>
                  )
                )}
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="w-full py-2 bg-gray-700 text-white font-bold rounded-lg hover:opacity-90 transition"
              >
                {isEditing ? "Update Intention" : "Add Intention"}
              </button>
            </form>
          </div>
        </div>
      )}

      <div className="container mx-auto overflow-x-auto p-6">
        <div className="mb-6 flex justify-end space-x-6">
          <button
            onClick={() => handleSort("type")}
            className="px-2 py-1 bg-gray-400 text-white rounded-full shadow-lg transform transition hover:scale-105"
          >
            Sort by Type
          </button>
          <button
            onClick={() => handleSort("lastModified")}
            className="px-2 py-1 bg-gray-400 text-white rounded-full shadow-lg transform transition hover:scale-105"
          >
            Last Modified
          </button>
          <button
            onClick={exportAsJSON}
            className="px-2 py-1 bg-gray-400 text-white rounded-full shadow-lg transform transition hover:scale-105"
          >
            JSON Download
          </button>
          <button
            onClick={exportAsExcel}
            className="px-2 py-1 bg-gray-400 text-white rounded-full shadow-lg transform transition hover:scale-105"
          >
            Download Excel Sheet
          </button>
        </div>

        <table className="min-w-full bg-white rounded-xl shadow-2xl overflow-hidden">
          <thead className="bg-gradient-to-r from-gray-700 via-gray-800 to-gray-900 text-white">
            <tr>
              <th className="px-6 py-4 text-sm font-semibold text-left">Id</th>
              <th className="px-6 py-4 text-sm font-semibold text-left">
                Intention
              </th>
              <th className="px-6 py-4 text-sm font-semibold text-left">
                Type
              </th>
              <th className="px-6 py-4 text-sm font-semibold text-left">
                Definition
              </th>
              <th className="px-6 py-4 text-sm font-semibold text-left">
                Techniques
              </th>
              <th className="px-6 py-4 text-sm font-semibold text-center">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {intentions.map((intention, index) => (
              <tr
                key={intention.id}
                className={`${
                  index % 2 === 0 ? "bg-gray-50" : "bg-gray-100"
                } hover:bg-white transition-all transform `}
              >
                <td className="px-6 py-4 text-sm text-gray-700 font-medium">
                  {index + 1}
                </td>
                <td className="px-6 py-4 text-sm text-gray-700">
                  {intention.intention}
                </td>
                <td className="px-6 py-4 text-sm text-gray-700">
                  {intention.type}
                </td>
                <td className="px-6 py-4 text-sm text-gray-700 max-w-xs truncate">
                  {intention.definition}
                </td>
                <td className="px-6 py-4 text-sm text-gray-700 max-w-xs truncate">
                  <ul className="list-disc pl-5 text-xs">
                    {Object.entries(intention.techniques).map(
                      ([technique, description]) => (
                        <li key={technique}>
                          <strong>{technique}:</strong>{" "}
                          {truncateText(description, 20)}
                        </li>
                      )
                    )}
                  </ul>
                </td>
                <td className="px-6 py-4 text-sm text-gray-700 flex justify-center space-x-4">
                  <button
                    onClick={() => handleView(intention.id)}
                    className="px-4 py-2 bg-gray-300 text-black rounded-full shadow-md transition-transform transform hover:scale-110"
                  >
                    View
                  </button>
                  <button
                    onClick={() => handleEdit(intention)}
                    className="px-4 py-2 bg-gray-300 text-black rounded-full shadow-md transition-transform transform hover:scale-110"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(intention.id)}
                    className="px-4 py-2 bg-gray-300 text-black rounded-full shadow-md transition-transform transform hover:scale-110"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {viewIntentionId && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center"
          onClick={handleCloseForm}
        >
          <div
            className="bg-white p-6 sm:p-8 rounded-lg shadow-md w-full sm:w-2/3 md:w-1/2 lg:w-1/3 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={handleCloseForm}
              className="absolute top-4 right-4 p-4 bg-gray-200 text-gray-600 rounded-full hover:bg-gray-300 transition"
            >
              ✖
            </button>
            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-gray-600">
                Intention:{" "}
                {
                  intentions.find((int) => int.id === viewIntentionId)
                    ?.intention
                }
              </h3>
              <p>
                <strong>Type:</strong>{" "}
                {intentions.find((int) => int.id === viewIntentionId)?.type}
              </p>
              <p>
                <strong>Definition:</strong>{" "}
                {
                  intentions.find((int) => int.id === viewIntentionId)
                    ?.definition
                }
              </p>
              <p>
                <strong>Techniques:</strong>
              </p>
              <ul className="list-disc pl-5 text-sm">
                {Object.entries(
                  intentions.find((int) => int.id === viewIntentionId)
                    ?.techniques || {}
                ).map(([technique, description]) => (
                  <li key={technique}>
                    <strong>{technique}:</strong> {description}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
      <div className="sticky-footer">
        <button
          onClick={handleAddIntention}
          className="mb-4 px-4 py-2 bg-gray-300 text-black rounded-full hover:bg-green-200 transition"
        >
          Add Intention
        </button>
      </div>
    </div>
  );
};

export default IntentionTechniquePage;
